import React, { useState } from "react";
import TextField from "../../../../../../components/input-fields/TextField";
import BaseModal from "../../../../../../components/modals/BaseModal";

const CustomDurationModal = ({ onClose, dataFromSnippet, onConfirm, onCancel, modalStyles }) => {
  const [time, setTime] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const onConfirmInternal = () => {
    if (time === "" || errorMessage !== "") {
      return;
    }
    
    const [hour, minute] = time.split(":");
    const duration = parseInt(hour) * 60 + parseInt(minute);

    onConfirm(duration);
    onClose();
  };

  const onCancelInternal = () => {
    onCancel();
    onClose();
  };

  const handleTimeChanged = (value) => {
    setTime(value);
    if (value === "") {
      setErrorMessage("Duration is required");
      return;
    }

    const [hour, minute] = value.split(":");
    const duration = parseInt(hour) * 60 + parseInt(minute);

    if (duration < dataFromSnippet.minDuration) {
      setErrorMessage(`Minimal duration is ${dataFromSnippet.minDuration} minutes`);
      return;
    }

    setErrorMessage("");
  };

  const headerChildren = (
    <div className="flex items-center justify-between w-full">
      <h2 className="text-[14px] md:text-[16px] lg:text-[18px] font-bold">Custom duration</h2>
    </div>
  );

  const bodyChildren = (
    <div className="flex flex-col gap-4">
      <TimePickerField time={time} setTime={handleTimeChanged} errorMessage={errorMessage} onSubmit={onConfirmInternal}/>
      <div className="flex gap-4 justify-end">
        <button
          className="w-full text-[12px] md:text-[14px] lg:text-[16px] text-gray-400 px-2 py-1 rounded-md  font-semibold "
          onClick={onCancelInternal}
        >
          Cancel
        </button>
        <button
          className="w-full text-primary text-[12px] md:text-[14px] lg:text-[16px] rounded-md px-2 py-1 font-semibold disabled:opacity-50"
          onClick={onConfirmInternal}
          disabled={time === "" || errorMessage !== ""}
        >
          Done
        </button>
      </div>
    </div>
  );

  return (
    <BaseModal
      headerChildren={headerChildren}
      bodyChildren={bodyChildren}
      onClose={onClose}
      width="w-[250px]"
      show={true}
      modalStyles={modalStyles}
    />
  );
};

const TimePickerField = ({ time, setTime, errorMessage, onSubmit }) => {
  return <TextField title="Duration" type="time" value={time} onChange={setTime} errorMessage={errorMessage} onSubmit={onSubmit}/>;
};

export default CustomDurationModal;
